import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import Adress from '../../template/Address/Address';
import Load from '../../template/Load/Load';
import WebViewHeader from '../../template/WebViewHeader/WebViewHeader';
import { COURSE_URL } from "../../constants";
import { parseQuery, myStorage } from '../../utils/tools';
import AXIOS from '../../api/axios';
import UA from '../../utils/ua';
// import clientApi from '../../api/client';

const queryObj = parseQuery(window.location.search.slice(1));

class AddressPage extends Component {
    constructor(props){
        super(props);
        this.isMobile = UA.mobileClient;
        this.addressId = props.location.state ? props.location.state.addressId : undefined;
        this.source = props.location.state ? props.location.state.source : null;
        this.storage = myStorage;
        const userAddress = this.storage.getItem('user_address');
        this.state = {
            completeRander: true,
            userAddress: userAddress ? JSON.parse(userAddress) : null,
            addressId: this.addressId,
        };
    }

    componentWillMount() {
        let isAllowAgreement = this.props.location.state.isAllowAgreement;
        if(isAllowAgreement) {
            localStorage.setItem('is_allow_agreement', isAllowAgreement)
        }
        localStorage.setItem('no_use_discount', this.props.location.state.notUseDiscount )
        let discountCoupon = this.props.location.state.discountCoupon;
        if(!!discountCoupon && Object.keys(discountCoupon).length > 0) {
            localStorage.setItem('user_discount', JSON.stringify(this.props.location.state.discountCoupon) )
        }
    }

    addAddress = (info) => {
        const { addressId } = this.state;
        const data = {userId:queryObj.stuid, ...info};
        const source = this.source ? this.source : 'nasamk';
        if(typeof addressId === 'undefined'){
            AXIOS.addAddress({
                data:data
            },(res, err) => {
                if(err) alert(err.errorMessage);
                else{
                    const { history } = this.props;            
                    history.replace({
                        pathname: `${COURSE_URL}/${source}`,
                        search:window.location.search,
                    });
                }
            })
        }
        else{
            AXIOS.setAddress({
                data: data,
                query: addressId + ''
            },(res, err) => {
                if(err) alert(err.errorMessage);
                else{
                    const { history } = this.props;            
                    history.replace({
                        pathname: `${COURSE_URL}/${source}`,
                        search:window.location.search,
                    });
                }
            })
        }
    }
    render(){
        const { userAddress } = this.state;
        return(
            <DocumentTitle title={'收货地址'} >
                <React.Fragment>
                    {!this.state.completeRander &&
                        <Load />
                    }
                    {!this.isMobile &&
                        <WebViewHeader showBack={true} showClose={false} title="收货地址"/>
                    }
                    <Adress defaultAddress={userAddress} addAddress={this.addAddress.bind(this)} />
                </React.Fragment>
            </DocumentTitle>
        )
    }
}

export default AddressPage;



// WEBPACK FOOTER //
// ./src/components/experimentOrderPage/AddressPage.jsx